import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { themeColor } from '../../Theming';

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
`;

const StepNumber = styled.div<{ isCurrent?: boolean }>`
  min-width: 30px;
  min-height: 30px;
  max-width: 30px;
  max-height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ isCurrent }) =>
    isCurrent ? themeColor('veryDarkGreen') : themeColor('mediumGrey')};
  border-radius: 30px;
  text-align: center;
  font-size: 0.938rem;
  margin-top: 8px;
  color: ${themeColor('white')};
  font-family: 'FrutigerLTStd-Light';
  margin-right: 0.5rem;
`;

const TextContainer = styled.div<{ isCurrent: boolean }>`
  font-size: 0.875rem;
  color: ${({ isCurrent }) =>
    isCurrent ? themeColor('veryDarkBlue') : themeColor('mediumGrey')};
  margin-right: 16px;
  display: inline;
`;

export const FirstA = styled.span`
  font-size: 12px;
`;

export const SecondA = styled.span`
  font-size: 16px;
`;

type ActivationStep = '1' | '2' | '3' | '4';

interface InstructionStepProps {
  step: ActivationStep;
  currentStep?: number;
}

const InstructionStep: React.FC<InstructionStepProps> = ({
  step,
  currentStep = 1,
}) => {
  const { t } = useTranslation();
  const isCurrent = currentStep >= Number(step);
  return (
    <Row id="stepContainer">
      <div id="stepNumber">
        <StepNumber isCurrent={isCurrent}>{step}</StepNumber>
      </div>
      <div id="stepText">
        <TextContainer isCurrent={isCurrent}>
          <Trans t={t} i18nKey={`PartnerpluginsdkActivate.li${step}`}>
            <FirstA>A</FirstA>
            <SecondA>A</SecondA>
          </Trans>
        </TextContainer>
      </div>
    </Row>
  );
};

export default InstructionStep;
